/* Search visible values within a Novva collection filter popover. Does not change filter selections. */
if (!window.__novvaFilterSearchBound) {
  window.__novvaFilterSearchBound = true;
  document.addEventListener('input', function (event) {
    var field = event.target;
    if (!(field instanceof HTMLInputElement) || !field.matches('[data-novva-filter-search]')) return;
    var panel = field.closest('.novva-filter-panel');
    if (!panel) return;
    var query = field.value.trim().toLocaleLowerCase();
    panel.querySelectorAll('.facets__inputs-list-item').forEach(function (item) {
      var label = item.querySelector('.checkbox__label-text, .facets__pill-label, .facets__swatch-label');
      item.hidden = !!query && (!label || !label.textContent.toLocaleLowerCase().includes(query));
    });
  });
}
